import { createCreateActionType, createCreateFetchingKey } from "@multiweb/reactUtils";

export const NAME = "workflowEditor";

/**
 * Pomocná funkce pro vytvoření typu akce
 * @param actionType Typ akce
 */
const createActionType = createCreateActionType(NAME);

/** Pomocná funkce pro vytvoření fetching key pro načtení lokalizací */
const createFetchingKey = createCreateFetchingKey(NAME);

/**
 * Klíč pro indikaci načítání lokalizací pro WFEditor
 */
export const FETCHING_KEY_WFEDITOR = createFetchingKey("WFEDITOR");

/**
 * Konstanta seznamu atributů pro čtení ze třídy WFStav (slouží pro)
 */
export const WFSTAV_ATTRIBUTES = ["Stav_dokladu"];

/**
 * Konstanty názvů akcí
 */
export const INIT_PICASSO_HOST = createActionType("INIT_PICASSO_HOST");
export const CLEAR_PICASSO_HOST = createActionType("CLEAR_PICASSO_HOST");
export const ENABLE_STATUS_VIEW = createActionType("ENABLE_STATUS_VIEW");
export const ENABLE_VIEWER_MODE = createActionType("ENABLE_VIEWER_MODE");
export const TOGGLE_GRID = createActionType("TOGGLE_GRID");
export const TOGGLE_EDIT_DIALOGS_VISIBILITY = createActionType("TOGGLE_EDIT_DIALOGS_VISIBILITY");
export const SET_TOUCHED = createActionType("SET_TOUCHED");
export const UPDATE_SETS = createActionType("UPDATE_SETS");
export const UPDATE_ACTIVITY = createActionType("UPDATE_ACTIVITY");
export const UPDATE_TRANSITION = createActionType("UPDATE_TRANSITION");
export const UPDATE_ACTIVITY_PROPERTY_PANEL_STATE = createActionType("UPDATE_ACTIVITY_PROPERTY_PANEL_STATE");
export const UPDATE_TRANSITION_PROPERTY_PANEL_STATE = createActionType("UPDATE_TRANSITION_PROPERTY_PANEL_STATE");
export const UPDATE_GENERAL_PROPERTY_PANEL_STATE = createActionType("UPDATE_GENERAL_PROPERTY_PANEL_STATE");
export const UPDATE_DEFINITION_PARTICIPANTS = createActionType("UPDATE_DEFINITION_PARTICIPANTS");
export const UPDATE_WORKFLOW_VIEW = createActionType("UPDATE_WORKFLOW_VIEW");
export const CREATE_TRANSITION = createActionType("CREATE_TRANSITION");
export const DELETE_SELECTED_WF_ENTITIES = createActionType("DELETE_SELECTED_WF_ENTITIES");
export const DELETE_SET = createActionType("DELETE_SET");
export const LOAD_ACTIVITY_HEADER = createActionType("LOAD_ACTIVITY_HEADER");
export const LOAD_TRANSITION_HEADER = createActionType("LOAD_TRANSITION_HEADER");
export const SHOW_MESSAGE_WINDOW = createActionType("SHOW_MESSAGE_WINDOW");
export const HIDE_MESSAGE_WINDOW = createActionType("HIDE_MESSAGE_WINDOW");
export const DIALOG_CONFIRMED = createActionType("DIALOG_CONFIRMED");
export const DIALOG_CANCELED = createActionType("DIALOG_CANCELED");
